export const DEFAULT_SLE_VALUES = {
  start: 1676041869,
  end: 1676042869,
  sle: {
    name: 'coverage',
    x_label: 'seconds',
    y_label: 'dBm',
    interval: 600,
    samples: {
      total: [48.983334],
      degraded: [0.0],
      value: [-57.220932],
    },
  },
  classifiers: [
    {
      name: 'weak-signal',
      x_label: 'seconds',
      y_label: 'user-minutes',
      interval: 600,
      samples: {
        total: [48.983334],
        duration: [0],
        degraded: [0],
      },
    },
    {
      name: 'asymmetry-uplink',
      x_label: 'seconds',
      y_label: 'user-minutes',
      interval: 600,
      samples: {
        total: [48.983334],
        duration: [0],
        degraded: [0],
      },
    },
    {
      name: 'asymmetry-downlink',
      x_label: 'seconds',
      y_label: 'user-minutes',
      interval: 600,
      samples: {
        total: [48.983334],
        duration: [0],
        degraded: [0],
      },
    },
  ],
}
